import { Store } from "pullstate";
import { getAttributesByGroup } from "../../attributes/lib/attribute-data";

const INITIAL_STATE = {
    groupData: {},
};

const AttributeGroupStore = new Store(INITIAL_STATE);
const fetching = {};

export const fetchAttributeGroup = async (groupId, codingWipKey) => {
    if (!groupId || fetching[groupId]) {
        return;
    }

    fetching[groupId] = true;
    const measuringAttributes = await getAttributesByGroup(groupId, { codingWipKey });

    if (!measuringAttributes) {
        return;
    }

    AttributeGroupStore.update((store) => {
        store.groupData[groupId] = measuringAttributes;

        return store;
    });
};

export default AttributeGroupStore;
